var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button subtitle-2"},[(_vm.icon.length)?_c('Icon',{staticClass:"icon",attrs:{"name":_vm.icon,"size":20}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }